import actionTypes from 'constants/actionTypes'
import cloneDeep from 'lodash/cloneDeep'
import defaultsDeep from 'lodash/defaultsDeep'

interface MeState {
  isFetching: boolean
  failedGet: boolean
  loggedIn: boolean
  lastUpdated?: number
  [key: string]: unknown
}

interface MeAction {
  type?: string
  payload?: {
    data?: Record<string, unknown>
  }
  meta?: {
    receivedAt?: number
  }
}

const defaultState = (): MeState => {
  return {
    isFetching: false,
    failedGet: false,
    loggedIn: false
  }
}

const single = (state: MeState = defaultState(), action: MeAction): MeState => {
  if (action.type === actionTypes.ME.GET.REQUEST) {
    return defaultsDeep(
      {
        failedGet: false,
        isFetching: true
      },
      state
    )
  }
  if (action.type === actionTypes.ME.GET.RECEIVE) {
    return defaultsDeep(
      {
        isFetching: false,
        failedGet: false,
        loggedIn: true,
        lastUpdated: action.meta?.receivedAt
      },
      action.payload?.data,
      state
    )
  }
  if (action.type === actionTypes.ME.GET.FAIL) {
    return defaultsDeep(
      {
        isFetching: false,
        failedGet: true,
        loggedIn: false,
        lastUpdated: action.meta?.receivedAt
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.LOGIN.REQUEST) {
    return defaultsDeep(
      {
        isFetching: true
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.LOGIN.RECEIVE) {
    return defaultsDeep(
      {
        isFetching: false,
        failedGet: false,
        loggedIn: true
      },
      action.payload?.data,
      state
    )
  }
  if (action.type === actionTypes.AUTH.SIGNUP.REQUEST) {
    return defaultsDeep(
      {
        isFetching: true
      },
      state
    )
  }
  if (action.type === actionTypes.AUTH.SIGNUP.RECEIVE) {
    return defaultsDeep(
      {
        isFetching: false,
        failedGet: false,
        loggedIn: true
      },
      action.payload?.data,
      state
    )
  }
  const actionType = action.type ?? ''
  if ([
    actionTypes.AUTH.MUST_LOGIN,
    actionTypes.AUTH.LOGOUT.REQUEST,
    actionTypes.AUTH.LOGOUT.RECEIVE,
    actionTypes.AUTH.LOGOUT.FAIL
  ].includes(actionType)) {
    return defaultsDeep(
      {
        loggedIn: false
      },
      state
    )
  }
  return cloneDeep(state)
}

export default single
